import { render } from "./Maps.vue?vue&type=template&id=ff3274f8"
import script from "./Maps.vue?vue&type=script&lang=js"
export * from "./Maps.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Desktop\\项目\\偏头痛\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__